import { Toggleable } from 'sane-ui'
import { gsap } from 'gsap'

class HeroMenu extends Toggleable {
  constructor ($el, args) {
    super($el, args)

    this.$lis = this.$el.find('li')
    this.$lisTL = this.$el.find('.hero-menu__list > li')
    this.$lisWS = this.$lisTL.filter('.menu-item-has-children') // links with submenus

    this.$lisWS.children('a')
      .on(
        'click',
        (event) => {
          event.preventDefault()

          const $a = $(event.currentTarget)
          const $submenu = $a.siblings('.sub-menu')
          const isSubmenuOpen = $submenu.is('.sub-menu--open')

          $a.toggleClass('active', !isSubmenuOpen)
          $submenu.toggleClass('sub-menu--open', !isSubmenuOpen)

          if (isSubmenuOpen) {
            gsap.to($submenu, 0.6, { height: 0, ease: 'power2.inOut' })
          } else {
            gsap.set($submenu, { height: 'auto' })
            gsap.from($submenu, 0.6, { height: 0, ease: 'power2.inOut' })
          }
        }
      )

    this.$el.on(
      'Toggleable/open',
      () => {
        window.app.toggleScrollLock(true)
      }
    )

    this.$el.on(
      'Toggleable/closed',
      () => {
        window.app.toggleScrollLock(false)
        this.$el.find('a.active').removeClass('active')
        const $openSubmenus = this.$el.find('.sub-menu--open')
        $openSubmenus.each(
          (i, el) => {
            const $submenu = $(el)
            $submenu.removeClass('sub-menu--open')
            gsap.set($submenu, { height: 0 })
          }
        )
      }
    )

    this.setUpLinks()
    this.setUpTimeline()
  }

  setUpTimeline () {
    this.timeline
      .clear()
      .to(this.$el, { duration: 0.01, autoAlpha: 1, ease: 'none' })
      .fromTo(
        this.$el.find('.hero-menu__scrim'),
        {
          autoAlpha: 0,
        },
        {
          duration: 0.2,
          autoAlpha: 1,
          ease: 'none',
        }
      )
      .fromTo(
        this.$lisTL,
        {
          x: '-30px',
          autoAlpha: 0,
        },
        {
          duration: 0.2,
          x: '0px',
          autoAlpha: 1,
          stagger: 0.05,
        },
        0.1
      )
      .fromTo(
        this.$lisTL.children('a').find('.line'),
        {
          scaleX: 0,
          autoAlpha: 0,
          transformOrigin: 'left',
        },
        {
          duration: 0.2,
          scaleX: 1,
          autoAlpha: 1,
          stagger: 0.05,
        },
        0.2
      )
  }

  setUpLinks () {
    const duration = 0.15

    // append lines
    this.$lis.each(
      (i, el) => {
        const $li = $(el)
        const isTL = $li.parent('.hero-menu__list').length > 0

        $li.find('a').each(
          (i, el) => {
            const $a = $(el)

            $a
              .wrapInner('<span class="link-text"></span>')
              .append('<span class="line"></span>')

            const $line = $a.find('.line')
            const timeline = gsap.timeline({ paused: true })

            $a
              .hover(
                () => {
                  if (timeline.paused) {
                    timeline.play()
                  }

                  timeline
                    .clear()

                  if (isTL) {
                    timeline
                      .set($line, { transformOrigin: 'right', immediateRender: false })
                      .to($line, { duration, scaleX: 0 })
                      .set($line, { backgroundColor: '#f0f', transformOrigin: 'left', immediateRender: false })
                      .to($line, { duration, scaleX: 1 })
                      .to($a, { duration, color: '#f0f', ease: 'none' }, duration / 2)
                  } else {
                    timeline
                      .to($line, { duration, scaleX: 1 })
                      .to($a, { duration, color: '#f0f', ease: 'none' })
                  }
                },
                () => {
                  timeline
                    .clear()

                  if (isTL) {
                    timeline
                      .set($line, { transformOrigin: 'right', immediateRender: false })
                      .to($line, { duration, scaleX: 0 })
                      .set($line, { backgroundColor: '#666', transformOrigin: 'left', immediateRender: false })
                      .to($line, { duration, scaleX: 1 })
                      .to($a, { duration, color: '#666', ease: 'none' }, duration / 2)
                  } else {
                    timeline
                      .to($line, { duration, scaleX: 0 })
                      .to($a, { duration, color: '#666', ease: 'none' })
                  }
                }
              )
          }
        )
      }
    )
  }
}

export default HeroMenu



// WEBPACK FOOTER //
// ./scripts/components/HeroMenu.js